import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { INITIAL_VESSELS_STORE_STATE, VesselsStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { signalStore, withComputed, withState } from '@ngrx/signals';
import { VESSELS_STORE_ID } from './constants';
import { buildVesselsVm } from './vessels-vm-builder';
import { withVesselsEffects } from './with-vessels-effects';
import { withVesselsReducer } from './with-vessels-reducer';

export const VesselsStore = signalStore(
  { providedIn: 'root' },
  withDevtools(VESSELS_STORE_ID, withGlitchTracking()),
  withState<VesselsStoreState>(INITIAL_VESSELS_STORE_STATE),
  withVesselsEffects(),
  withVesselsReducer(),
  withComputed((store) => {
    return {
      vm: computed(() => {
        const vessels = store.vessels();
        return buildVesselsVm(vessels);
      }),
    };
  })
);
